import {statusTypes} from '@/core/constants'

export default {
    defaultObject: {
        status: statusTypes.ACTIVATED,
        iofConfig: {},
        receiptConfig: {},
        installmentConfig: {},
    }
}
